import { render } from "./TicketBanner.vue?vue&type=template&id=f0a981a4"
import script from "./TicketBanner.vue?vue&type=script&lang=js"
export * from "./TicketBanner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__